import { Link } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";

import ThumbsUp from "components/svgIcons/ThumbsUp";
import themeImgTest from "assets/img/marketplace/theme-img-test.png";
import { useStorePath } from "@hooks/useStorePath";

const ThemeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { storePath } = useStorePath();

  if (!id) {
    return <h1 className="text-red-500">Error: Theme ID Not Found</h1>;
  }

  return (
    <div className="mt-[2em] flex flex-col gap-[4em]">
      <div className="flex gap-[1em]">
        <div className="flex flex-col h-fit m-0 bg-white rounded-lg gap-[2em] py-[2em] px-[2em] w-[30%]">
          <div className="flex flex-col gap-[1em]">
            <span className="text-[30px] font-bold">MetroShop Pro</span>
            <span className="text-[14px] font-normal">Ksh 499/-</span>
            <span className="text-[16px] font-medium">
              A clean and modern eCommerce theme for fashion stores.
            </span>
            <span className="flex flex-row content-center gap-[0.3em] text-[14px] font-normal">
              <ThumbsUp />
              4.0 (210 Reviews)
            </span>
          </div>

          <Link
            className="CTA-link bg-[#000000] dark:bg-white inline text-center"
            to={storePath(`billing/${id}`)}
          >
            <span className="text-white hover:underline dark:text-navy-700">Buy now</span>
          </Link>
        </div>

        <div className="flex flex-col">
          <div className="relative rounded-lg overflow-hidden">
            {/* Scrollable container */}
            <div className="h-[450px] overflow-y-auto aspect-[16/9]">
              <img
                src={themeImgTest}
                alt="Theme Preview"
                className="w-full h-auto object-contain brightness-[1.4] contrast-[1.05]"
              />
            </div>
          </div>
          <p className="text-sm text-gray-500 mt-2">*Scroll theme for preview</p>
        </div>
      </div>

      {/* Theme features */}
      <div className="bg-white rounded-lg p-6 md:p-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Column */}
          <div>
            <h3 className="text-[15px] font-bold mb-3 mt-6">THIS THEME IS GREAT FOR</h3>
            <ul className="space-y-2 text-[15px] text-gray-600">
              <li>Ideal for small-scale businesses</li>
              <li>Designed for growing stores</li>
              <li>Optimized for high-traffic shops</li>
              <li>Great for product-focused brands</li>
              <li>Suited for service-based businesses</li>
            </ul>

            <h3 className="text-[15px] font-bold mb-3 mt-6">CHECKOUT AND PAYMENT FEATURES</h3>
            <ul className="space-y-2 text-[15px] text-gray-600">
              <li>Supports multiple payment methods</li>
              <li>Enables one-click checkout</li>
              <li>Offers discount and coupon options</li>
              <li>Includes abandoned cart recovery</li>
            </ul>
          </div>

          {/* Right Column */}
          <div>
            <h3 className="text-[15px] font-bold mb-3 mt-6">SALES AND MARKETING FEATURES</h3>
            <ul className="space-y-2 text-[15px] text-gray-600">
              <li>SEO-optimized for better search rankings</li>
              <li>Includes newsletter signup form</li>
              <li>Supports popups and promo banners</li>
              <li>Displays trust and security badges</li>
              <li>Integrates with social media platforms</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeDetails;
